<template>
  <div>
    <barChart v-if="chartType == 10" :style="chartData.style" :option="chartData.chart_data"></barChart>
  </div>
</template>

<script>
import barChart from './barChart'
export default {
  props: {
    chartType: {
      type: Number,
      default() {
        return 0
      }
    },
    chartData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
    }
  },
  methods: {
  },
  created() {
    console.log('chartData = ', _g.j2s(this.chartData.chart_data))
  },
  components: {
    barChart
  }
}
</script>


// WEBPACK FOOTER //
// chartsTable.vue?00be03da